import AdminRouteSelector, { AdminRoute } from "@app/components/admin-route-selector.tsx";
import { Box } from "@mui/material";
import { createFileRoute, Outlet } from "@tanstack/react-router";

const routes: AdminRoute[] = [
    { to: "/admin/expense/accounting-categories", name: "Accounting Categories" },
    { to: "/admin/expense/accounting-codes", name: "Accounting Codes" },
    { to: "/admin/expense/expense-subcategories", name: "Expense Subcategories" },
    {
        to: "/admin/expense/reimbursable-expense-exceptions",
        name: "Reimbursable expense exceptions",
    },
    { to: "/admin/expense/subcategory-groups", name: "Subcategory Groups" },
    { to: "/admin/expense/time-expense-categories", name: "Time & Expense Categories" },
];

export const Route = createFileRoute("/_authenticated/_admin/admin/expense")({
    component: Component,
});

function Component() {
    return (
        <>
            <AdminRouteSelector routes={routes} />
            <Box width={"100%"} mt={2}>
                <Outlet />
            </Box>
        </>
    );
}
